import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-detail_menu-open",
  "use": "icon-detail_menu-open-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-detail_menu-open\">\n  <g>\n    <path stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" d=\"M5 7.243l4.243 4.242 4.242-4.242\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol